export default __webpack_public_path__ + "static/person-4621f9b72abb2c24701faa572523032a.png";